import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Button from '../../../../../components/Button';
import Anchor from '../../../../../components/link/Anchor';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { DISCOUNT_TYPE_TEXT } from '../../../../../constants/service/app/productConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  reDirectPage,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setClearComma,
  setNumberWithComma,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { PRODUCT_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';

/**
 *  상품 전체 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, getProductTagColumnTagList, getProductSubCategoryList } = data;
  return [
    {
      Header: '승인하기',
      fixed: 'left',
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="승인하기"
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(PRODUCT_DETAIL_URL_PATH, row.original.productId),
            })
          }
        />
      ),
    },
    {
      accessor: 'url',
      Header: '메인 이미지',
      fixed: 'left',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      fixed: 'left',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      fixed: 'left',
      width: 120,
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      fixed: 'left',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'rejectCnt',
      Header: '승인 거절 횟수',
      fixed: 'left',
      width: 100,
    },
    {
      accessor: 'brandName',
      Header: '브랜드',
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'brandName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      fixed: 'left',
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      Header: '태그',
      Cell: (row) =>
        row.original.isTagExists ? (
          <Anchor
            text="태그 보기"
            isUnderLine
            color="primary"
            onClick={() => getProductTagColumnTagList({ productId: row.original.productId })}
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'productNumber',
      Header: '제품번호',
    },
    {
      accessor: 'originPrice',
      Header: '판매가(원)',
      filterable: true,
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.originPrice}
          onFilter={(originPrice) =>
            onFilter({
              originPrice: setClearComma(originPrice),
            })
          }
        />
      ),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가(원)',
      filterable: true,
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.discountPrice}
          onFilter={(discountPrice) =>
            onFilter({
              discountPrice: setClearComma(discountPrice),
            })
          }
        />
      ),
    },
    {
      accessor: 'discountRate',
      Header: '할인율',
      filterable: true,
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value, '%'),
      Filter: () => (
        <TableFilterInput
          option={filterOption.discountRate}
          onFilter={(discountRate) =>
            onFilter({
              discountRate,
            })
          }
        />
      ),
    },
    {
      accessor: 'discountType',
      Header: '할인설정',
      Cell: (row) => setDash(DISCOUNT_TYPE_TEXT[row.value]),
    },
    {
      accessor: 'discountedPrice',
      Header: '할인된 판매가(원)',
      sortable: true,
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountStartDate',
      Header: '할인 시작일',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'discountEndDate',
      Header: '할인 종료일',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'createDate',
      Header: '상품 등록일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      accessor: 'updateDate',
      Header: '최종 수정일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.updateDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ updateDate: data })}
        />
      ),
    },
  ];
};

export default columns;
